import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Header from "../../Header";
import DOMPurify from "dompurify";
import Pagination from "react-js-pagination";
import { Multiselect } from "multiselect-react-dropdown";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment, { unix } from "moment";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
// import Swal from "sweetalert2";
import PopOver from "./PopOver";
import EditorNew from "./../Editor/EditorNew";
import ChatDetailsCommon from "./ChatDetailsCommon";
import { NavLink, Redirect, withRouter, useLocation } from "react-router-dom";
import Async, { useAsync } from "react-select/async";
import Select, { components } from "react-select";
import InlineEdit from "./InlineEdit";
import CopyLink from "./components/CopyLink";
import Cookies from "js-cookie";
import Skeleton from "react-loading-skeleton";
import NoDataFound from "./NoDataFound";
import OffCanvas from "./OffCanvas";
import { Link } from "react-router-dom";
import LoadImageApi from "../chat/components/LoadImageApi";
import { checkCrmPermission, encodeDecodeRequest, maskEmail, maskPhone, retriveResponeValue } from "../crm/customer/Utility";
import { Timeline } from "./components/CustomTimeline";
import "./chat.css";
import { getFormattedDate } from "../../actions/common";
import { toast } from "react-toastify";
import Tooltip from "rsuite/Tooltip";
import Whisper from "rsuite/Whisper";
import InteractionsModal from "./components/InteractionsModal";

const ChatDetails = (props) => {
	const [chatList, setChatList] = useState([]);
	const [isShow, setIsShow] = useState(true);
	const [currentPage, setcurrentPage] = useState(1);
	const [perPage, setperPage] = useState(20);
	const [totalCount, settotalCount] = useState(0);
	const [offSet, setoffSet] = useState(0);
	const [search, setSearch] = useState("");
	const [prodName, setprodName] = useState([]);
	const [podName, setpodName] = useState([]);
	const [featureName, setfeatureName] = useState([]);
	const [removeModal, setRemoveModal] = useState(false);
	const [highlightedColumns, setHighlightedColumns] = useState([]);
	const [filterItem, setFilterItem] = useState({});
	const [chatDetail, setChatDetail] = useState({});
	const [chatInformation, setChatInformation] = useState({});
	const [infoEdit, setInfoEdit] = useState(false);
	const [formData, setFormData] = useState({});
	const [chatNotes, setChatNotes] = useState({});
	const [noteContent, setNoteContent] = useState("");
	const [transcriptId, setTranscriptId] = useState(props.match.params.id);
	const [userList, setUserList] = useState({});
	const [displayIcon, setDisplayIcon] = useState(false);
	const [chatIndex, setChatIndex] = useState(0);
	const [selectText, setSelectText] = useState([]);
	const [userUUID, setUserUUID] = useState(0);
	const [highlightChat, setHighlightChat] = useState([]);
	const [chatContent, setChatContent] = useState("");
	const [rawText, setRawText] = useState("");
	const [isHistoryLoading, setIsHistoryLoading] = useState(false);
	const [isCopied, setIsCopied] = useState(false);
	const [isNoteCopied, setIsNoteCopied] = useState(false);
	const [character, setCharacter] = useState("");
	const [currentIndex, setCurrentIndex] = useState("");
	const [activeTab, setActiveTab] = useState(1);
	const [editId, setEditId] = useState(1);
	const [error, setError] = useState({ error: true, message: "" });
	const [noteAdding, setNoteAdding] = useState(0);
	const [noteError, setNoteError] = useState(false);
	const [feedbackData, setFeedbackData] = useState([]);
	const [history, setHistory] = useState([]);
	const initialChatDetailRef = useRef({});
	const [chatLoading, setChatLoading] = useState(false);
	const [showCanvas, setShowCanvas] = useState(false);
	const [chatNextPrev, setChatNextPrev] = useState({});
	const [showImagePopup, setshowImagePopup] = useState(false);
	const [imgSrc, setImageSrc] = useState("");
	const [showInteractionsModal, setShowInteractionsModal] = useState(false);
	const [selectedInteractionsId, setSelectedInteractionsId] = useState(null);
	const [copyChatLink, setCopyChatLink] = useState("");

	const userSelection = useRef(null);
	const chatRef = useRef([]);
	const chatContainerRef = useRef(null);
	const noteContainerRef = useRef(null);
	const lastScrolledHash = useRef('');
	// Helper: get element offset relative to scrolling container
	const getRelativeOffsetTop = (el, container) => {
		let offset = 0;
		let node = el;
		while (node && node !== container) {
			offset += node.offsetTop;
			node = node.offsetParent;
		}
		return offset;
	};

	// Helper: find element by hash - first try id selector then data-hash
	const getElementByHash = (hash) => {
		if (!hash) return null;
		// hash may be like '#123' or '#noteId456'
		let el = null;
		try {
			el = document.querySelector(hash);
		} catch (err) {
			// invalid selector if hash contains characters; ignore
		}
		if (el) return el;
		const name = hash.startsWith("#") ? hash.slice(1) : hash;
		return document.querySelector(`[data-hash="${name}"]`);
	};
	const crmPermission = checkCrmPermission();

	const searchParams = new URLSearchParams(props.location.search);
	let debug = searchParams.get("debug");

	const callReadApi = (transcriptId) => {
		const userUuid = Cookies.get("muvi_useruuid");
		const response = fetch(`${process.env.REACT_APP_CRM}/live-chat/read`, {
			method: "POST",
			body: JSON.stringify({
				customer_tattle_uuid: +transcriptId,
				user_uuid: userUuid,
				// user_uuid: "da675b5a796a439d867db54b5ced81c7",
			}),
		})
			.then((res) => res.json())
			.then((rdata) => null);
		setUserUUID(userUuid);
	};

	useEffect(() => {
		chatDetails(transcriptId);
		if (window.location.href.indexOf("noteId") > -1) {
			setActiveTab(2);
		}
		if (window.location.href.indexOf("Information") > -1) {
			setActiveTab(3);
		} else {
			setActiveTab(1);
		}
		fetch(`${process.env.REACT_APP_INTRANET_API}/tattle/productList`)
			.then((item) => {
				return item.json();
			})
			.then((data) => {
				setprodName(data);
			});

		fetch(`${process.env.REACT_APP_INTRANET_API}/tattle/podList`)
			.then((item) => {
				return item.json();
			})
			.then((data) => {
				setpodName(data);
			});

		fetch(`${process.env.REACT_APP_INTRANET_API}/tattle/featureList`)
			.then((item) => {
				return item.json();
			})
			.then((data) => {
				setfeatureName(data);
			});

		fetch(`${process.env.REACT_APP_CRM}/user-list`, {
			method: "POST",
		})
			.then((resp) => {
				return resp.json();
			})
			.then((data) => {
				if (data.code == 200) {
					setUserList(data.data);
				}
			})
			.catch((err) => console.log(err));
		callReadApi(transcriptId);
		
		// Prevent browser from auto-restoring scroll on navigation
		if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
			window.history.scrollRestoration = 'manual';
		}

		document.title = `${props.match.params.id || ""} | Chat`;
		return () => {
			document.title = "";
		};
	}, []);

	useEffect(() => {
		window.addEventListener("mousedown", clickOutSidehandler);
		return () => {
			window.removeEventListener("mousedown", clickOutSidehandler);
		};
	}, [currentIndex]);

	const clickOutSidehandler = (e) => {
		if (chatRef.current[currentIndex] && !chatRef.current[currentIndex].contains(e.target)) {
			setDisplayIcon(false);
		} else {
			// setDisplayIcon(true);
		}
	};

	useEffect(() => {
		getUserUUID();
	}, [userList]);

	const chatDetails = (transcript_id) => {
		const userId = Cookies.get("muvi_useruuid");
		setChatInformation({});
		setChatDetail({});
		setChatLoading(true);
		let requests = {
			customer_tattle_uuid: transcript_id,
			user_uuid: userId,
		};

		if (debug) {
			requests = {
				...requests,
				debug: true,
			};
		}
		try {
			const response = fetch(process.env.REACT_APP_CRM + `/live-chat/chat-details`, {
				method: "POST",
				body: encodeDecodeRequest(debug, requests),
			});

			response
				.then((data) => {
					return retriveResponeValue(debug, data);
				})
				.then((item) => {
					if (item.code == 200) {
						console.log("Chat Details Response", item.data);
						setChatLoading(false);
						setChatDetail(item.data);
						initialChatDetailRef.current = item.data;
						setChatInformation(item.data);
						setChatNextPrev({ next: item.next, prev: item.prev });
					} else {
						props.history.push("/chat");
					}
				})
				.catch((err) => {
					props.history.push("/chats");
				});

			// fetch(process.env.REACT_APP_CRM + "/live-chat/get-highlight-chat", {
			//   method: "POST",
			//   body: JSON.stringify({
			//     customer_tattle_uuid: transcript_id,
			//   }),
			// })
			//   .then((i) => {
			//     return i.json();
			//   })
			//   .then((res) => {
			//     if (res.code == 200) {
			//       setHighlightChat(res.data);
			//     }
			//   });
		} catch (error) {
			console.log(error.message);
		}

		setTranscriptId(transcript_id);
		getChatNotes(transcript_id);
	};

	async function feedbackAsyncCall(evt, name = null) {
		return await fetch(
			process.env.REACT_APP_tattle_api +
			`/tattle/rows/?app_token=${process.env.REACT_APP_tattle_token}&attribute_set_key=${name || "idea"
			}&search=${evt}`
		)
			.then((resp) => {
				return resp.json();
			})
			.then((i) => {
				let records = i.data.map((item) => {
					return {
						label: `${item.customer_tattle_uuid} - ${item.title}`,
						value: item.customer_tattle_uuid,
					};
				});
				setFeedbackData(records);
				return records;
			});
	}

	const getChatNotes = (id) => {
		try {
			let requests = {
				customer_tattle_uuid: Number(id),
				attribute_set_key: "live-chat",
				app_token: process.env.REACT_APP_tattle_token,
				attribute_set_type: 20,
			};

			const output = fetch(`${process.env.REACT_APP_tattle_api}/notes/list`, {
				method: "POST",
				body: JSON.stringify(requests),
			});

			output
				.then((i) => {
					return i.json();
				})
				.then((out) => {
					setChatNotes(out);
				});
		} catch (err) {
			console.log(err.message);
		}
	};

	const saveInformation = (e) => {
		e.preventDefault();
		const { pod, product, feature, preview, name, email, transcript_id, ideas } = formData;

		var pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		if (email.length == 0) {
			setError({ error: true, message: "Email Id can not be blank" });
			return false;
		} else {
			if (!email.match(pattern)) {
				setError({ error: true, message: "Please enter valid email id" });
				return false;
			} else {
				setError({ error: false, message: "" });
			}
		}

		const params = {
			transcript_id: transcript_id,
			pod: pod,
			product: product,
			ideas: ideas,
			feature: feature,
			preview: preview,
			name: name,
			email: email,
		};

		fetch(process.env.REACT_APP_CRM + "/live-chat/update-information", {
			method: "POST",
			body: JSON.stringify(params),
		})
			.then((res) => res.json())
			.then((item) => {
				setChatInformation({
					...chatInformation,
					pod: pod,
					product: product,
					ideas: ideas,
					feature: feature,
					preview: preview,
					name: name,
					email: email,
				});
				setInfoEdit(!infoEdit);
				// chat(currentPage);
			});
	};

	const editFormHandler = (field = null, e) => {
		const { name, value } = e.target;

		var pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (name === "email" && value.length === 0) {
			setError({ error: true, message: "Email Id can not be blank" });
		} else if (!value.match(pattern)) {
			setError({ error: true, message: "Please enter valid email Id" });
		} else {
			setError({ error: false, message: "" });
		}
		setFormData({ ...formData, [name]: value });
	};

	const editBtnHandler = () => {
		setInfoEdit(!infoEdit);
		setFormData(chatInformation);
	};

	const decrypt = (findresponse, flg) => {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	};

	const getUserUUID = () => {
		const userdetails = decrypt(localStorage.getItem("encdata"), 0);
		const data = userList;
		const emp_id = parseInt(userdetails.user_id);
		let userUuid = null;

		for (const key in data) {
			if (data.hasOwnProperty(key)) {
				const user = data[key];
				if (user.emp_id === emp_id) {
					userUuid = user.user_uuid;
					break;
				}
			}
		}
		setUserUUID(userUuid);
	};
	useEffect(() => {
		(async () => {
			setIsHistoryLoading(true);
			if (chatDetail.customer_tattle_uuid) {
				const response = await fetch(`${process.env.REACT_APP_CRM}/live-chat/get-chat-message`, {
					method: "POST",
					body: JSON.stringify({
						customer_tattle_uuid: chatDetail.customer_tattle_uuid,
						chat_type: chatDetail.chat_type,
						id: Number(chatDetail.id),
					}),
				});

				const rdata = await response.json();

				if (rdata.code === 200) {
					setIsHistoryLoading(false);
					const { history = [], formatted_chat = [] } = rdata.data;
					if (formatted_chat.length > 0 && history.length > 0) {
						formatted_chat.forEach((item) => {
							if (item.message) {
								history[item.index].msg = item.message;
							}
						});
					}
					setHistory(history || []);
				}
			}
		})();
	}, [chatDetail]);

	const noteAdd = (e) => {
		e.preventDefault();
		setNoteAdding(1);
		setEditId(editId + 1);
		let str = noteContent.chat_note.html_content;
		let strippedStr = str.replace(/(&nbsp;)|(<([^>]+)>)/gi, ""); // Remove &nbsp; and HTML tags
		if (noteContent.chat_note.html_content == "" || strippedStr.trim() === "") {
			setNoteError(true);
			setNoteAdding(0);
			return false;
		} else {
			setNoteError(false);
			setNoteContent("");
			const useruuid = Cookies.get("muvi_useruuid");
			fetch(`${process.env.REACT_APP_tattle_api}/note/create`, {
				method: "POST",
				body: JSON.stringify({
					attribute_set_key: "live-chat",
					app_token: process.env.REACT_APP_tattle_apptoken,
					customer_tattle_uuid: +transcriptId,
					user_uuid: useruuid,
					note_content: noteContent.chat_note.html_content,
					note_content_json: JSON.stringify(
						noteContent.chat_note.draft_js_content &&
						noteContent.chat_note.draft_js_content
					),
					mention: noteContent.mentioned_data && noteContent.mentioned_data,
					highlight_text: "",
					note_type: "live-chat",
					attribute_set_type: 20,
				}),
			})
				.then((item) => {
					return item.json();
				})
				.then((data) => {
					setNoteAdding(0);
					getChatNotes(transcriptId);
				});
		}
	};
	const navigationChatHandler = (id) => {
		if (id) {
			chatDetails(id);
			props.history.push({
				pathname: `/chat/${id}`,
				state: {
					pageNumber: props.location && props.location.state && props.location.state.pageNumber,
				},
			});
			callReadApi(id);
		}
	};

	const showCanvasHandler = () => {
		setShowCanvas(true);
	};

	const offCanvas = () => {
		setShowCanvas(false);
	};
	const showPopupHandler = (imgsrc) => {
		setshowImagePopup(true);
		setImageSrc(imgsrc);
	};

	const closePopupHandler = () => {
		setshowImagePopup(false);
	};

	//update feature
	const updateFeatureHandler = (field, evt, action) => {
		const formdataedit = { ...formData };
		if (field === "ideas") {
			formdataedit[field] = evt.map((it) => it.value);
			setChatInformation((state) => {
				return {
					...state,
					[field]: evt.map((it) => it.value),
				};
			});
		} else {
			if (evt != undefined) {
				if (Array.isArray(evt)) {
					formdataedit[field] = evt.map((item) => item.value);
				} else {
					formdataedit[field] = evt.map((it) => Number(it.id));
				}
			}
		}

		setFormData(formdataedit);
	};

	const InputOption = ({ getStyles, Icon, isDisabled, isFocused, isSelected, children, innerProps, ...rest }) => {
		// styles
		let bg = "transparent";
		if (isFocused) bg = "#f4f7fc";

		const style = {
			alignItems: "center",
			backgroundColor: bg,
			color: "inherit",
			display: "flex ",
		};

		// prop assignment
		const props = {
			...innerProps,
			style,
		};

		return (
			<components.Option
				{...rest}
				isDisabled={isDisabled}
				isFocused={isFocused}
				isSelected={isSelected}
				getStyles={getStyles}
				innerProps={props}
			>
				<input type="checkbox" checked={isSelected} style={{ marginRight: "5px", marginTop: "0px" }} />
				{children}
			</components.Option>
		);
	};

	const getEditForm = () => {
		return (
			<div>
				<div class="input-box">
					<form onSubmit={saveInformation}>
						<div class="infoBtn">
							<button class="informDone" type="submit">
								<span>
									<svg
										width="17"
										height="16"
										viewBox="0 0 17 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clip-path="url(#clip0_51_1921)">
											<path
												d="M8.49992 14.6667C12.1818 14.6667 15.1666 11.6819 15.1666 8.00001C15.1666 4.31811 12.1818 1.33334 8.49992 1.33334C4.81802 1.33334 1.83325 4.31811 1.83325 8.00001C1.83325 11.6819 4.81802 14.6667 8.49992 14.6667Z"
												fill="#0CB9F2"
												stroke="#0CB9F2"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
											<path
												d="M11.8332 6L7.83325 10.6667L5.83325 9"
												stroke="#F2F2F2"
												stroke-width="1.33"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
										</g>
										<defs>
											<clipPath id="clip0_51_1921">
												<rect
													width="16"
													height="16"
													fill="white"
													transform="translate(0.5)"
												></rect>
											</clipPath>
										</defs>
									</svg>
								</span>
								Done
							</button>
							<button class="informCancel" onClick={() => setInfoEdit(!infoEdit)}>
								<span>
									<svg
										width="17"
										height="16"
										viewBox="0 0 17 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clip-path="url(#clip0_51_1927)">
											<path
												d="M8.49992 14.6667C12.1818 14.6667 15.1666 11.6819 15.1666 8.00001C15.1666 4.31811 12.1818 1.33334 8.49992 1.33334C4.81802 1.33334 1.83325 4.31811 1.83325 8.00001C1.83325 11.6819 4.81802 14.6667 8.49992 14.6667Z"
												fill="#666666"
												stroke="#666666"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
											<path
												d="M10.5 6L6.5 10"
												stroke="#F2F2F2"
												stroke-width="1.33"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
											<path
												d="M6.5 6L10.5 10"
												stroke="#F2F2F2"
												stroke-width="1.33"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
										</g>
										<defs>
											<clipPath id="clip0_51_1927">
												<rect
													width="16"
													height="16"
													fill="white"
													transform="translate(0.5)"
												></rect>
											</clipPath>
										</defs>
									</svg>
								</span>
								Cancel
							</button>
						</div>
						<div class="input-box">
							<label class="input-label">Summary</label>
							<div class="bunch-span">
								<textarea
									type="text"
									class="form-control"
									placeholder="Enter Summary"
									name="preview"
									onChange={(evt) => editFormHandler("preview", evt)}
								>
									{formData && formData.preview}
								</textarea>
							</div>
						</div>

						<div class="input-box">
							<label class="input-label">Product</label>
							<div class="bunch-span">
								<Select
									isMulti
									className="multi-select"
									classNamePrefix="multi-select"
									closeMenuOnSelect={true}
									hideSelectedOptions={false}
									options={prodName.map((item) => {
										return { label: item.value, value: item.id };
									})}
									displayValue="label"
									closeOnSelect={false}
									onChange={(e) => updateFeatureHandler("product", e)}
									value={prodName
										.map((item) => {
											return { label: item.value, value: item.id };
										})
										.filter((it) => formData.product && formData.product.includes(it.value))}
									components={{
										Option: InputOption,
									}}
								/>
							</div>
						</div>
						<div class="input-box">
							<label class="input-label">POD</label>
							<div class="bunch-span">
								<Select
									isMulti
									className="multi-select"
									classNamePrefix="multi-select"
									// closeMenuOnSelect={true}
									hideSelectedOptions={false}
									options={podName.map((item) => {
										return { label: item.value, value: item.id };
									})}
									displayValue="label"
									closeOnSelect={false}
									onChange={(e) => updateFeatureHandler("pod", e)}
									value={podName
										.map((item) => {
											return { label: item.value, value: item.id };
										})
										.filter((it) => formData.pod && formData.pod.includes(it.value))}
									components={{
										Option: InputOption,
									}}
								/>
							</div>
						</div>
						<div class="input-box">
							<label class="input-label">Feature</label>
							<div class="bunch-span">
								<Select
									isMulti
									className="multi-select"
									classNamePrefix="multi-select"
									closeMenuOnSelect={true}
									hideSelectedOptions={false}
									options={featureName.map((item) => {
										return { value: item.id, label: item.value };
									})}
									displayValue="label"
									closeOnSelect={false}
									onChange={(e) => updateFeatureHandler("feature", e)}
									value={featureName
										.map((item) => {
											return { label: item.value, value: item.id };
										})
										.filter((it) => formData.feature && formData.feature.includes(it.value))}
									components={{
										Option: InputOption,
									}}
								/>
							</div>
						</div>
						<div class="input-box">
							<label class="input-label">Ideas</label>
							<div class="bunch-span">
								{console.log("feedback data", feedbackData, formData.ideas)}
								<Async
									cacheOptions
									defaultOptions
									className="multi-select"
									classNamePrefix="multi-select"
									loadOptions={(evt) => feedbackAsyncCall(evt)}
									isClearable
									isMulti
									onChange={(evt, ac) => updateFeatureHandler("ideas", evt, ac)}
									value={
										formData.ideas &&
										formData.ideas.map((item) => {
											return { label: item, value: item };
										})
									}
									components={{
										Option: InputOption,
									}}
								/>
							</div>
						</div>

						<div class="input-box">
							<label class="input-label">Lead Name</label>
							<div class="bunch-span">
								<input
									type="text"
									class="form-control"
									id=""
									placeholder="Enter Lead Name"
									onChange={(evt) => editFormHandler("name", evt)}
									name="name"
									value={formData && formData.name}
								/>
							</div>
						</div>
						<div class="input-box">
							<label class="input-label">Email ID</label>
							<div class="bunch-span">
								<input
									type="email"
									class="form-control"
									id=""
									onChange={(evt) => editFormHandler("email", evt)}
									name="email"
									placeholder="Enter Email ID"
									value={formData && formData.email}
								/>
								{error.error ? <label className="error-msg">{error.message}</label> : ""}
							</div>
						</div>
					</form>
				</div>
			</div>
		);
	};
	
	// Minimal hash scrolling: handle initial hash and later hashchange with retries
	useLayoutEffect(() => {
		if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
			window.history.scrollRestoration = 'manual';
		}

		const scrollToHash = (hash) => {
			if (!hash) return;
			if (lastScrolledHash.current === hash) return; // already scrolled
			const container = hash.includes('noteId') ? noteContainerRef.current : chatContainerRef.current;
			if (!container) return;

			let attempts = 0;
			const maxAttempts = 20;

			const tryFind = () => {
				attempts++;
				const el = getElementByHash(hash);
				if (el) {
					const relativeTop = getRelativeOffsetTop(el, container);
					const scrollTop = relativeTop - (container.clientHeight / 2) + (el.clientHeight / 2);
					container.scrollTo({ top: Math.max(0, scrollTop), behavior: 'smooth' });
					lastScrolledHash.current = hash;
					return;
				}
				if (attempts < maxAttempts) setTimeout(tryFind, 100);
			};

			tryFind();
		};

		// initial
		scrollToHash(props.location && props.location.hash);

		// on change
		const onHash = () => scrollToHash(window.location.hash);
		window.addEventListener('hashchange', onHash);
		return () => window.removeEventListener('hashchange', onHash);
	}, [props.location && props.location.hash, history, chatNotes]);

	const convertNoteList = (data) => {
		const linkRegex = /<a[^>]*>.*?<\/a>|((http:\/\/|https:\/\/)[^\s]+)/gi;

		return data.replace(linkRegex, (match, group1) => {
			if (group1) {
				return `<a href="${group1.replace(/<p>/g, "").replace(/<\/p>/g, "")}" target="_blank">${group1}</a>`;
			} else {
				return match;
			}
		});
	};
	const getFormattedChatDate = () => {
		let date;
		if (chatDetail && chatDetail.timestamp) {
			date = new Date(chatDetail.timestamp);
			return date.toLocaleDateString("en-US", {
				month: "short",
				day: "2-digit",
				year: "numeric",
			});
		}
		return "";
	};

	const addChatNote = (chatData) => {
		setNoteContent(chatData);
	};

	let chatHistory = [];
	if (chatDetail.history && chatDetail.history.length) {
		chatHistory = chatDetail.history;
	}

	let customCss = {
		chips: {
			background: "#F1FCFF",
		},
	};

	const highlightSelection = (e, chat_index) => {
		try {
			var selection = window.getSelection();
			setCurrentIndex(chat_index);
			if (selection.anchorNode) {
				var parentElement = selection.anchorNode.parentElement;
				if (parentElement) {
					var innerHTMLValue = parentElement.innerHTML;

					setRawText(innerHTMLValue);
				} else {
				}
			}

			setChatIndex(chat_index);
			// setDisplayIcon(true);
			userSelection.current = window.getSelection() && window.getSelection().getRangeAt(0);
			var safeRanges = getSafeRanges(userSelection);
			setSelectText(safeRanges);
		} catch (err) {
			console.log(err.message);
		}
	};

	const applyColor = () => {
		try {
			for (var i = 0; i < selectText.length; i++) {
				highlightRange(selectText[i]);
			}
			let parentEl = userSelection.current.commonAncestorContainer;
			if (parentEl.nodeType != 1) {
				parentEl = parentEl.parentNode;
			}
			setChatContent(parentEl.innerHTML);
		} catch (err) {
			console.log(err.message);
		}
	};

	const highlightRange = (range) => {
		var newNode = document.createElement("div");
		newNode.className = "highlights";
		newNode.setAttribute("style", "background-color: yellow; display: inline;");
		range.current && range.current.surroundContents(newNode);
	};

	const updateChat = () => {
		let params = {
			chat_index: chatIndex,
			customer_tattle_uuid: transcriptId,
			chat_content: chatContent,
		};
		fetch(process.env.REACT_APP_CRM + "/live-chat/update-chat", {
			method: "POST",
			body: JSON.stringify(params),
		})
			.then((item) => {
				return item.json();
			})
			.then((data) => {
				console.log(data);
			});
	};
	const removeColor = () => {
		var elements = document.getElementsByClassName("highlights");

		// Remove each element with the class 'highlights'
		for (var i = 0; i < elements.length; i++) {
			var content = elements[i].innerHTML;
			elements[i].outerHTML = content;
		}
		setChatContent(rawText);
	};

	const getSafeRanges = (dangerous) => {
		var a = dangerous.commonAncestorContainer;
		// Starts -- Work inward from the start, selecting the largest safe range
		var s = new Array(0),
			rs = new Array(0);
		if (dangerous.startContainer != a) {
			for (var i = dangerous.startContainer; i != a; i = i.parentNode) {
				s.push(i);
			}
		}
		if (s.length > 0) {
			for (var i = 0; i < s.length; i++) {
				var xs = document.createRange();
				if (i) {
					xs.setStartAfter(s[i - 1]);
					xs.setEndAfter(s[i].lastChild);
				} else {
					xs.setStart(s[i], dangerous.startOffset);
					xs.setEndAfter(s[i].nodeType == Node.TEXT_NODE ? s[i] : s[i].lastChild);
				}
				rs.push(xs);
			}
		}

		// Ends -- basically the same code reversed
		var e = new Array(0),
			re = new Array(0);
		if (dangerous.endContainer != a) {
			for (var i = dangerous.endContainer; i != a; i = i.parentNode) {
				e.push(i);
			}
		}
		if (e.length > 0) {
			for (var i = 0; i < e.length; i++) {
				var xe = document.createRange();
				if (i) {
					xe.setStartBefore(e[i].firstChild);
					xe.setEndBefore(e[i - 1]);
				} else {
					xe.setStartBefore(e[i].nodeType == Node.TEXT_NODE ? e[i] : e[i].firstChild);
					xe.setEnd(e[i], dangerous.endOffset);
				}
				re.unshift(xe);
			}
		}

		// Middle -- the uncaptured middle
		if (s.length > 0 && e.length > 0) {
			var xm = document.createRange();
			xm.setStartAfter(s[s.length - 1]);
			xm.setEndBefore(e[e.length - 1]);
		} else {
			return [dangerous];
		}

		// Concat
		rs.push(xm);
		let response = rs.concat(re);

		// Send to Console
		return response;
	};

	let newchatHistory = [];
	newchatHistory = chatHistory.map((item) => {
		let highlightchatdata =
			highlightChat && highlightChat.length > 0 && highlightChat.find((it) => it.index == item.index);
		if (highlightchatdata) {
			return { ...item, message: highlightchatdata.message };
		} else {
			return item;
		}
	});
	const postRef = useRef(null);
	const handleMouseUp = (e) => {
		const selection = window.getSelection();

		if (selection.rangeCount > 0) {
			const range = selection.getRangeAt(0);
			const selectedNode = range.commonAncestorContainer;

			// Find the parent paragraph element
			let paragraphElement = selectedNode.nodeType === 3 ? selectedNode.parentNode : selectedNode;

			// Extract the text content of the paragraph
			const paragraphText = paragraphElement.textContent;

			setRawText(paragraphText);
		}
		const selectedText = `${window.getSelection().toString()}`;
		if (selectedText.length > 0) {
			setDisplayIcon(true);

			setCharacter(selectedText);
		} else {
			setDisplayIcon(false);

			setCharacter("");
		}
	};

	const shareLink = () => {
		navigator.clipboard.writeText(`${window.location.href}`);
		setIsCopied(true);
		setTimeout(() => {
			setIsCopied(false);
		}, 800);
	};

	const copyLink = (id) => {
		navigator.clipboard.writeText(`${window.location.origin}/chat/${transcriptId}#noteId${id}`);
		setIsNoteCopied(true);
		setTimeout(() => {
			setIsNoteCopied(false);
		}, 800);
	};
	const onSubmitHandler = (data) => {
		const { transcript_id } = formData;
		let params = {};
		const keys = Object.keys(data);
		const values = Object.values(data);

		if (keys[0] === "ideas") {
			const { customer_tattle_uuid, isAdding, ideas } = data;

			params = {
				user_uuid: "da675b5a796a439d867db54b5ced81c7",
				attribute_set_key: "live_chat",
				app_token: process.env.REACT_APP_tattle_apptoken,
				customer_tattle_uuid: Number(props.match.params.id),
				project: {
					ideas: values[0],
				},
			};

			fetch(process.env.REACT_APP_tattle_api + "/live-chat/update", {
				method: "POST",
				body: JSON.stringify(params),
			});
			setChatInformation((state) => {
				return {
					...state,
					ideas: ideas && ideas.map((it) => it),
				};
			});
			return;
		}

		if (Array.isArray(values[0])) {
			params = {
				[keys[0]]: values[0].map((it) => it.value),
				customer_tattle_uuid: Number(props.match.params.id),
			};
			setChatInformation((state) => {
				return {
					...state,
					[keys[0]]: values[0].map((it) => it.value),
				};
			});
		} else {
			params = {
				[keys[0]]: values[0],
				customer_tattle_uuid: Number(props.match.params.id),
			};
			setChatInformation((state) => {
				return {
					...state,
					[keys[0]]: values[0],
				};
			});
		}
		fetch(process.env.REACT_APP_CRM + "/live-chat/update-information", {
			method: "POST",
			body: JSON.stringify(params),
		})
			.then((res) => res.json())
			.then((item) => { });
	};
	const getCountryNameByCode = (ccode) => {
		let regionNames = new Intl.DisplayNames(["en"], { type: "region" });
		return regionNames.of(ccode);
	};
	const createHyperlinks = (text) => {
		// // Check if text already contains an anchor tag
		// if (/<a\s+(?:[^>]*?\s+)?href=/.test(text)) {
		// 	return text; // Return original text if it already has a link
		// }

		// const urlRegex = /(https?:\/\/[^\s]+)/g; // Regex to match URLs
		// return text.replace(urlRegex, (url) => {
		// 	return `<a href="${url}" style="color:#0e7fe1" target="_blank" rel="noopener noreferrer">${url}</a>`;
		// });

		 // Let DOMPurify strip harmful attributes/scripts
		 if (!text) return "";

		// Step 1: Sanitize all HTML to remove unsafe attributes/scripts
		const sanitized = DOMPurify.sanitize(text, {
			ALLOWED_URI_REGEXP: /^https?:\/\//i, // block javascript: and data: links
		});

		// Step 2: Auto-link plain URLs that are not already inside <a>
		// Use negative lookbehind to ignore URLs already inside <a>
		const urlRegex = /(?<!href="|">)(https?:\/\/[^\s<]+)/g;

		const linked = sanitized.replace(urlRegex, (url) => {
			return `<a href="${url}" style="color:#0e7fe1" target="_blank" rel="noopener noreferrer">${url}</a>`;
		});

		return linked;
	};
	const getFlagEmoji = (countryCode) =>
		String.fromCodePoint(...[...countryCode.toUpperCase()].map((x) => 0x1f1a5 + x.charCodeAt()));

	const toggleReviewStatus = (item, index) => {
		const reviewStatus = item.review_status || 0;

		if (chatDetail.chat_version == 'v1') {
			if (reviewStatus === 1) {
				return;
			}

			const resp = fetch(`${process.env.REACT_APP_ALIE_API_URL}/alie/v1/message/review`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					interaction_id: item.interaction_id,
				}),
			})
			.then((res) => {
				console.log("Review status updated", res);
				if (res.status == 200) {
					const newHistory = [...history];
					newHistory[index].review_status = 1;
					setHistory(newHistory);
					toast.success("Review status updated successfully");
				} else {
					toast.error("Failed to update review status");
				}
			});
			return;
		} else {
			const resp = fetch(`${process.env.REACT_APP_CRM}/live-chat/set-chat-review-status`, {
				method: "POST",
				body: JSON.stringify({
					interaction_id: item.interaction_id,
					review_status: reviewStatus === 1 ? 0 : 1,
				}),
			})
				.then((res) => res.json())
				.then((res) => {
					console.log("Review status updated", res);
					if (res.code === 200) {
						const newHistory = [...history];
						newHistory[index].review_status = reviewStatus === 1 ? 0 : 1;
						setHistory(newHistory);
						toast.success("Review status updated successfully");
					} else {
						toast.error("Failed to update review status");
					}
				});
		}
	}

	const activeUserList = Object.keys(userList)
		.filter((key) => userList[key].is_active === 1)
		.reduce((res, key) => {
			res[key] = userList[key];
			return res;
		}, {});

	return (
		<React.Fragment>
			<div>
				<Header brecum_name="Live Chat Transcript" brecum_page="Live Chat Transcript" />

				<div class="right_col fullchatarea">
					<div class="full-chat-area collapse in" id="full-chat-area" aria-expanded="true">
						<div class="row margin-lr-0">
							<React.Fragment>
								<div class="col-md-3 chat-padding-0">
									<div class="chat-middle">
										<div class="chat-right-title">
											<div className="arrow-nav">
												<NavLink
													to={{
														pathname: "/chats/list",
														state: {
															pageNumber:
																props.location &&
																props.location.state &&
																props.location.state.pageNumber,
														},
													}}
												>
													<i class="fa fa-arrow-left"></i>{" "}
												</NavLink>
												ID: {transcriptId}
											</div>

											<div className="chat-pagination">

												<div class="button-group">
													<button
														class="button"
														onClick={() => navigationChatHandler(chatNextPrev.prev)}
														disabled={!chatNextPrev.prev ? true : false}
														style={!chatNextPrev.prev ? { background: "#80808026" } : {}}
													>
														⟨
													</button>
													<button
														class="button"
														onClick={() => navigationChatHandler(chatNextPrev.next)}
														disabled={!chatNextPrev.next ? true : false}
														style={!chatNextPrev.next ? { background: "#80808026" } : {}}
													>
														⟩
													</button>
												</div>
											</div>
										</div>

										<div class="information-viewarea">
											{!infoEdit ? (
												<div>
													{/* <div class="infoBtn">
                              <button
                                class="informDone"
                                onClick={() => editBtnHandler()}
                              >
                                <span>
                                  <i
                                    class="fa fa-pencil-square-o"
                                    aria-hidden="true"
                                  ></i>
                                </span>
                                Edit
                              </button>
                            </div> */}

													<div class="input-box">
														<label class="input-label">Product</label>

														<InlineEdit
															type="select"
															options={prodName.map((item) => {
																return { label: item.value, value: item.id };
															})}
															displayValue="label"
															closeOnSelect={false}
															value={prodName
																.map((item) => {
																	return {
																		label: item.value,
																		value: item.id,
																	};
																})
																.filter(
																	(it) =>
																		chatInformation.product &&
																		chatInformation.product.includes(it.value)
																)}
															components={{
																Option: InputOption,
															}}
															name="product"
															onSubmit={onSubmitHandler}
														>
															<div class="bunch-span">
																{chatInformation &&
																	chatInformation.product &&
																	chatInformation.product.length
																	? chatInformation.product
																		.map((prod) => {
																			return prodName.filter(
																				(item) => item.id == prod
																			);
																		})
																		.map((ii, i) => {
																			return ii.map((io) => (
																				<span>
																					{io.value}
																					{i !==
																						chatInformation.product.length -
																						1
																						? `, `
																						: ""}
																				</span>
																			));
																		})
																	: ""}
															</div>
														</InlineEdit>
													</div>
													<div class="input-box">
														<label class="input-label">Pod</label>
														<InlineEdit
															type="select"
															options={podName.map((item) => {
																return { label: item.value, value: item.id };
															})}
															displayValue="label"
															closeOnSelect={false}
															value={podName
																.map((item) => {
																	return {
																		label: item.value,
																		value: item.id,
																	};
																})
																.filter(
																	(it) =>
																		chatInformation.pod &&
																		chatInformation.pod.includes(it.value)
																)}
															components={{
																Option: InputOption,
															}}
															name="pod"
															onSubmit={onSubmitHandler}
														>
															<div class="bunch-span">
																{chatInformation &&
																	chatInformation.pod &&
																	chatInformation.pod.length
																	? chatInformation.pod
																		.map((pd) => {
																			return podName.filter(
																				(item) => item.id == pd
																			);
																		})
																		.map((ii, i) => {
																			return ii.map((io) => (
																				<span>
																					{io.value}
																					{i !==
																						chatInformation.pod.length - 1
																						? `, `
																						: ""}
																				</span>
																			));
																		})
																	: ""}
															</div>
														</InlineEdit>
													</div>
													{ /* <div class="input-box">
														<label class="input-label">Feature</label>
														<InlineEdit
															type="select"
															className="multi-select"
															classNamePrefix="multi-select"
															closeMenuOnSelect={true}
															hideSelectedOptions={false}
															options={featureName.map((item) => {
																return { value: item.id, label: item.value };
															})}
															displayValue="label"
															closeOnSelect={false}
															value={featureName
																.map((item) => {
																	return {
																		label: item.value,
																		value: item.id,
																	};
																})
																.filter(
																	(it) =>
																		chatInformation.feature &&
																		chatInformation.feature.includes(it.value)
																)}
															components={{
																Option: InputOption,
															}}
															name="feature"
															onSubmit={onSubmitHandler}
														>
															<div class="bunch-span">
																{chatInformation &&
																chatInformation.feature &&
																chatInformation.feature.length
																	? chatInformation.feature
																			.map((feat) => {
																				return featureName.filter(
																					(item) => item.id == feat
																				);
																			})
																			.map((ii, i) => {
																				return ii.map((io) => (
																					<span>
																						{io.value}
																						{i !==
																						chatInformation.feature.length -
																							1
																							? `, `
																							: ""}
																					</span>
																				));
																			})
																	: ""}
															</div>
														</InlineEdit>
													</div> */}
													<div class="input-box">
														<label class="input-label">Feature</label>
														<InlineEdit
															type="async"
															cacheOptions
															defaultOptions
															className="multi-select"
															classNamePrefix="multi-select"
															loadOptions={(evt) =>
																feedbackAsyncCall(evt, "fd")
															}
															feedbackData={feedbackData || []}
															isClearable
															isMulti
															onChange={(evt, ac) =>
																updateFeatureHandler("fd", evt, ac)
															}
															value={
																chatInformation.fd &&
																chatInformation.fd.map((item) => {

																	return (item && item.value) || item;
																})
															}
															components={{
																Option: InputOption,
															}}
															name="fd"
															onSubmit={onSubmitHandler}
															updateFeatureHandler={updateFeatureHandler}
														>

															<p>
																{chatInformation &&
																	chatInformation.fd &&
																	Array.isArray(chatInformation.fd) &&
																	chatInformation.fd.some(
																		(e) => e !== null && e !== undefined
																	)
																	? chatInformation.fd
																		.filter(
																			(e) => e !== null && e !== undefined
																		)
																		.map((e, i, arr) => (
																			<a
																				href={`${process.env.REACT_APP_tattle}/tattle/fd/${e}`}
																				target="_blank"
																				rel="noopener noreferrer"
																				key={i}
																			>
																				{e}
																				{i !== arr.length - 1 ? `, ` : ""}
																			</a>
																		))
																	: ""}
															</p>
														</InlineEdit>
													</div>
													<div class="input-box">
														<label class="input-label">Ideas</label>
														<InlineEdit
															type="async"
															cacheOptions
															defaultOptions
															className="multi-select"
															classNamePrefix="multi-select"
															loadOptions={(evt) => feedbackAsyncCall(evt)}
															feedbackData={feedbackData || []}
															isClearable
															isMulti
															onChange={(evt, ac) =>
																updateFeatureHandler("ideas", evt, ac)
															}
															value={
																chatInformation.ideas &&
																chatInformation.ideas.map((item) => {
																	return item.value || item;
																})
															}
															components={{
																Option: InputOption,
															}}
															name="ideas"
															onSubmit={onSubmitHandler}
															updateFeatureHandler={updateFeatureHandler}
														>
															<p>
																{chatInformation &&
																	chatInformation.ideas &&
																	chatInformation.ideas.length
																	? chatInformation.ideas.map((e, i) => {
																		return (
																			<a
																				href={`${process.env.REACT_APP_tattle}/tattle/ideas/${e}`}
																				target="_blank"
																			>
																				{e}
																				{i !==
																					chatInformation.ideas.length - 1
																					? `, `
																					: ""}
																			</a>
																		);
																	})
																	: ""}
															</p>
														</InlineEdit>
													</div>
													<div class="input-box">
														<label class="input-label">Summary</label>
														<InlineEdit
															type="text"
															value={
																chatInformation &&
																chatInformation.preview &&
																chatInformation.preview.length &&
																chatInformation.preview
															}
															name="preview"
															onSubmit={onSubmitHandler}
														>
															<p>
																{chatInformation &&
																	chatInformation.preview &&
																	chatInformation.preview.length
																	? chatInformation.preview.length > 20
																		? chatInformation.preview.slice(0, 20) + "..."
																		: chatInformation.preview
																	: ""}
															</p>
														</InlineEdit>
													</div>
													<div class="input-box">
														<label class="input-label">Lead Name</label>
														<InlineEdit
															type="text"
															value={chatInformation && chatInformation.name}
															name="name"
															onSubmit={onSubmitHandler}
														>
															<p>{(chatInformation && chatInformation.name) || "-NA-"}</p>
														</InlineEdit>
													</div>

													<div class="input-box">
														<label class="input-label">Email ID</label>
																					{
																						crmPermission ? (
																							<InlineEdit
																								type="email"
																								value={chatInformation && chatInformation.email}
																								name="email"
																								onSubmit={onSubmitHandler}
																							>
																								<p>
																									{chatInformation &&
																										chatInformation.email &&
																										chatInformation.email.length > 20
																										? maskEmail(
																											chatInformation.email.slice(0, 20) + "...",
																											2,
																											"email"
																										)
																										: maskEmail(
																											chatInformation.email || "",
																											2,
																											"email"
																										)}
																								</p>
																							</InlineEdit>
																						) : (
																								<p>
																									{chatInformation &&
																										chatInformation.email &&
																										chatInformation.email.length > 20
																										? maskEmail(
																											chatInformation.email.slice(0, 20) + "...",
																											2,
																											"email"
																										)
																										: maskEmail(
																											chatInformation.email || "",
																											2,
																											"email"
																										)}
																								</p>
																						)
																					}
													</div>
												</div>
											) : (
												getEditForm()
											)}
										</div>
									</div>
								</div>
								<div class="col-md-6 chat-padding-0">
									<div class="chat-middle">
										<div class="topbar">
											<div class="leftone">
												<div class="f-Name">
													{chatDetail && chatDetail.name
														? chatDetail.name.length > 40
														? chatDetail.name.slice(0, 40) + "..."
														: chatDetail.name
														: "-NA-"}
												</div>
												<div class="f-desc">
													<span class="gmail">
														<i className="fa fa-envelope"></i>{" "}
														{chatDetail && chatDetail.email && chatDetail.email ? (
															<React.Fragment>
																{maskEmail(chatDetail.email, 2, "email").length > 35
																	? maskEmail(chatDetail.email, 2, "email").slice(
																		0,
																		35
																	) + "..."
																	: maskEmail(chatDetail.email, 2, "email").slice(
																		0,
																		35
																	) + ""}
															</React.Fragment>
														) : (
															"--"
														)}
													</span>
													<span class="phone ml-2">
														<i className="fa fa-mobile"></i>{" "}
														{chatDetail && chatDetail.phone && chatDetail.phone ? (
															<React.Fragment>
																{maskPhone(chatDetail.phone, 2, "phone")}
															</React.Fragment>
														) : (
															"--"
														)}
													</span>
												</div>
											</div>
											<div class="rightone">
												<div class="inner-rightone" id="innerRightone">
													<NavLink to={`/idea/${transcriptId}`} class="informDone">
														<div>
															<i class="fa fa-plus"></i>
															&nbsp; Add Idea
														</div>
													</NavLink>
												</div>
												<div
													class="collapse-search"
													id="collapseSearch"
													style={{ display: "none" }}
												>
													<input type="search" class="mssg-input" placeholder="Search Here" />
												</div>
											</div>
										</div>
										{/* <div class="top-head">
											{showImagePopup && (
												<LoadImageApi
													closePopupHandler={closePopupHandler}
													id={chatDetail.id}
													url={imgSrc}
												/>
											)}
											
											<div class="head-item">
												<span class="time">{getFormattedDate()}</span>
												{chatDetail.country_code && (
													<span style={{ display: "flex", alignItems: "center" }}>
														<img
															src={`https://flagcdn.com/48x36/${chatDetail.country_code &&
																chatDetail.country_code.toLowerCase()
																}.png`}
															width="14px"
														/>
														&nbsp;
														{chatDetail.country
															? chatDetail.country
															: getCountryNameByCode(chatDetail.country_code)}
													</span>
												)}
												{chatDetail.department_name && (
													<span
														title={chatDetail.department_name && chatDetail.department_name}
													>
														<i className="fa fa-building" aria-hidden="true"></i>
														&nbsp;
														{chatDetail.department_name}
													</span>
												)}
												{chatInformation.email && (
													<span>
														<a
															href={`https://app.hubspot.com/contacts/570609/record/0-1/${chatInformation.email}`}
															target="_blank"
															rel="noopener noreferrer"
															className="hubspot-button"
														>
															<i className="fas fa-link hubspot-icon"></i> Hubspot
														</a>
													</span>
												)}
												{/* {chatDetail.agent_names && (
													<span>
														{" "}
														<i className="fa fa-user-circle" aria-hidden="true"></i>
														&nbsp;{chatDetail.agent_names}
													</span>
												)} 
												{chatDetail.chat_status && chatDetail.chat_status.toLowerCase() === "missed" ? (
													<span>
														<i className="fa fa-user-circle" aria-hidden="true"></i>
														&nbsp;Offline
													</span>
												) : (
													chatDetail.agent_names && (
														<span>
															<i className="fa fa-user-circle" aria-hidden="true"></i>
															&nbsp;{chatDetail.agent_names}
														</span>
													)
												)}

												<span onClick={showCanvasHandler}>
													<i className="fa fa-info-circle"></i>
												</span>
											</div>
											<span onClick={shareLink}>
												{isCopied ? <span>Link Copied</span> : ""}
												<svg
													width="16"
													height="16"
													viewBox="0 0 16 16"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<g clip-path="url(#clip0_126_9222)">
														<path
															d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z"
															stroke="#666666"
															stroke-width="1.33"
															stroke-linecap="round"
															stroke-linejoin="round"
														></path>
														<path
															d="M3.33301 9.99998H2.66634C2.31272 9.99998 1.97358 9.8595 1.72353 9.60946C1.47348 9.35941 1.33301 9.02027 1.33301 8.66665V2.66665C1.33301 2.31302 1.47348 1.97389 1.72353 1.72384C1.97358 1.47379 2.31272 1.33331 2.66634 1.33331H8.66634C9.01996 1.33331 9.3591 1.47379 9.60915 1.72384C9.8592 1.97389 9.99967 2.31302 9.99967 2.66665V3.33331"
															stroke="#666666"
															stroke-width="1.33"
															stroke-linecap="round"
															stroke-linejoin="round"
														></path>
													</g>
													<defs>
														<clipPath id="clip0_126_9222">
															<rect width="16" height="16" fill="white"></rect>
														</clipPath>
													</defs>
												</svg>
											</span>
										</div> */}

										<div className="top-head">
											{showImagePopup && (
												<LoadImageApi
													closePopupHandler={closePopupHandler}
													id={chatDetail.id}
													url={imgSrc}
												/>
											)}

											<div className="head-item-scroll">
												{/* Date */}
												<div
												className="head-section"
												title={getFormattedChatDate()}
												>
												{getFormattedChatDate()}
												</div>

												{/* Country */}
												{chatDetail.country_code && (
													<div
														className="head-section"
														title={
															chatDetail.country
																? chatDetail.country
																: getCountryNameByCode(chatDetail.country_code)
														}
													>
														<img
															src={`https://flagcdn.com/48x36/${chatDetail.country_code.toLowerCase()}.png`}
															width="14"
															alt="flag"
															style={{ marginRight: "4px" }}
														/>
														{chatDetail.country
															? chatDetail.country
															: getCountryNameByCode(chatDetail.country_code)}
													</div>
												)}

												{/* Department */}
												{chatDetail.department_name && (
													<div className="head-section" title={chatDetail.department_name}>
														<i className="fa fa-building" aria-hidden="true"></i>&nbsp;
														{chatDetail.department_name}
													</div>
												)}

												{/* HubSpot */}
												{chatInformation.email && (
													<div className="head-section" title={chatInformation.email}>
														<a
															href={`https://app.hubspot.com/contacts/570609/record/0-1/${chatInformation.email}`}
															target="_blank"
															rel="noopener noreferrer"
															className="hubspot-button"
														>
															<i className="fas fa-link hubspot-icon"></i>&nbsp;Hubspot
														</a>
													</div>
												)}

												{/* Agent or Offline */}
												{chatDetail.chat_status &&
													chatDetail.chat_status.toLowerCase() === "missed" ? (
													<div className="head-section" title="Offline">
														<i className="fa fa-user-circle" aria-hidden="true"></i>&nbsp;Offline
													</div>
												) : (
													chatDetail.agent_names && (
														<div className="head-section" title={chatDetail.agent_names}>
															<i className="fa fa-user-circle" aria-hidden="true"></i>&nbsp;
															{chatDetail.agent_names}
														</div>
													)
												)}

												{/* Info icon */}
												<div
													className="head-section no-separator"
													onClick={showCanvasHandler}
													title="More Info"
													style={{ cursor: "pointer", maxWidth: "unset", flexShrink: 0 }}
												>
													<i className="fa fa-info-circle"></i>
												</div>
											</div>

											{/* Share icon */}
											<span onClick={shareLink} style={{ marginLeft: "10px", cursor: "pointer" }}>
												{isCopied ? <span>Link Copied</span> : ""}
												<svg
													width="16"
													height="16"
													viewBox="0 0 16 16"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<g clipPath="url(#clip0_126_9222)">
														<path
															d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z"
															stroke="#666666"
															strokeWidth="1.33"
															strokeLinecap="round"
															strokeLinejoin="round"
														/>
														<path
															d="M3.33301 9.99998H2.66634C2.31272 9.99998 1.97358 9.8595 1.72353 9.60946C1.47348 9.35941 1.33301 9.02027 1.33301 8.66665V2.66665C1.33301 2.31302 1.47348 1.97389 1.72353 1.72384C1.97358 1.47379 2.31272 1.33331 2.66634 1.33331H8.66634C9.01996 1.33331 9.3591 1.47379 9.60915 1.72384C9.8592 1.97389 9.99967 2.31302 9.99967 2.66665V3.33331"
															stroke="#666666"
															strokeWidth="1.33"
															strokeLinecap="round"
															strokeLinejoin="round"
														/>
													</g>
													<defs>
														<clipPath id="clip0_126_9222">
															<rect width="16" height="16" fill="white" />
														</clipPath>
													</defs>
												</svg>
											</span>
										</div>
										{chatDetail && chatDetail.chat_type === "alie" && (
											<div className="survey-reaction">
												<div className="reactions-title">
													Chat Feedback:&nbsp;
												</div>
												<div className="reactions">
													<span
														title="Very Good"
														className={
														chatDetail.survey_reaction === "very_good"
															? "active-reaction"
															: ""
														}
													>
														{"😄"}
													</span>
													&nbsp;
													<span
														title="Good"
														className={
														chatDetail.survey_reaction === "good"
															? "active-reaction"
															: ""
														}
													>
														{"🙂"}
													</span>
													&nbsp;
													<span
														title="Average"
														className={
														chatDetail.survey_reaction === "average"
															? "active-reaction"
															: ""
														}
													>
														{"😐"}
													</span>
													&nbsp;
													<span
														title="Bad"
														className={
														chatDetail.survey_reaction === "bad"
															? "active-reaction"
															: ""
														}
													>
														{"😕"}
													</span>
													&nbsp;
													<span
														title="Very Bad"
														className={
														chatDetail.survey_reaction === "very_bad"
															? "active-reaction"
															: ""
														}
													>
														{"😡"}
													</span>
												</div>
											</div>
										)}

										<div class="midle-full-chatbox" ref={chatContainerRef}>
											{/* <div class="head-title">
                        {chatDetail.preview && chatDetail.preview} */}
											{/* <i class="fa fa-map-marker" aria-hidden="true"></i> */}
											{/* </div> */}
											{!isHistoryLoading ? (
												history.length > 0 ? (
													history.map((item, hindex) => {
														if (
															item.hasOwnProperty("type") &&
															item.type === "chat.memberjoin"
														) {
															return (
																<p className="text-center">{item.name} has Joined</p>
															);
														}

														if (
															item.hasOwnProperty("type") &&
															item.type === "chat.memberleave"
														) {
															return <p className="text-center">{item.name} has Leave</p>;
														}

														if (
															item.hasOwnProperty("type") &&
															item.type === "chat.changeemail"
														) {
															return (
																<p className="text-center">
																	Email Changed to {item.new_email}
																</p>
															);
														}

														if (
															item.hasOwnProperty("type") &&
															item.type === "chat.changename"
														) {
															return (
																<p className="text-center">
																	Name Changed to {item.newname}
																</p>
															);
														}

														if (
															item.hasOwnProperty("type") &&
															item.type === "chat.rating"
														) {
															return (
																<p className="text-center">
																	Chat Rating - {item.new_rating}
																</p>
															);
														}

														if (item.sender_type === "Visitor") {
															return (
																<div class="single-recieve">
																	<div class="img-box">
																		<img src={`https://ui-avatars.com/api/?name=${item.name}&color=ff0000&size=40&background=random`} />
																	</div>
																	<div
																		class="mssg-dec"
																		ref={(el) => (chatRef.current[hindex] = el)}
																	>
																		<p>
																			{item.name}{" "}
																			<span>
																				{getFormattedDate(
																				item.timestamps || item.timestamp,
																				"hh:mm a"
																				)}{" "}
																				{`(${moment(
																				item.timestamps || item.timestamp
																				).fromNow()})`}
																			</span>
																		</p>
																		<div className="message-main-body">
																			<div
																				class="mssg-text"
																				style={{
																					textAlign: "left"
																				}}
																				onMouseUp={(e) => {
																				highlightSelection(e, hindex);
																				handleMouseUp(e);
																				}}
																			>
																				{item.hasOwnProperty("msg") ? (
																				<span
																					dangerouslySetInnerHTML={{
																					__html: createHyperlinks(
																						item.msg
																					),
																					}}
																				></span>
																				) : (
																				item.msg
																				)}
																				{item.hasOwnProperty("file") &&
																				item.file.hasOwnProperty(
																					"file_src"
																				) && (
																					<div
																					className="img-upload-body"
																					onClick={() =>
																						showPopupHandler(
																						item.file.zoho_url
																						)
																					}
																					>
																					<img
																						src={item.file.file_src}
																						alt=""
																					/>
																					</div>
																				)}
																			</div>
																		</div>

																		{displayIcon && hindex == chatIndex ? (
																			<PopOver
																				obj={{
																					transcriptId,
																					chatIndex,
																					userUUID,
																					applyColor,
																					userList,
																					getChatNotes,
																					setDisplayIcon,
																					updateChat,
																					chatContent,
																					removeColor,
																				}}
																			/>
																		) : (
																			""
																		)}
																	</div>
																</div>
															);
														} else if (item.sender_type === "event") {
															// return (
															// 	<div className="event-message">
															// 		{
															// 			item.hasOwnProperty("msg") && (
															// 			<span
															// 				dangerouslySetInnerHTML={{
															// 					__html: createHyperlinks(
															// 						item.msg
															// 					),
															// 				}}
															// 			></span>)
															// 		}
															// 	</div>
															// )
														} else {
															return (
																<div
																	class="single-sender"
																	data-hash={`${item.interaction_id}`}
																>
																	<div
																		class="mssg-dec"
																		ref={(el) => (chatRef.current[hindex] = el)}
																	>
																		<p
																		style={{
																			display: "flex",
																			justifyContent: "space-between",
																		}}
																		>
																		<div
																			style={{
																			display: "flex",
																			alignItems: "center",
																			gap: "8px",
																			}}
																		>
																			<div class="img-box">
																			<img src={`https://ui-avatars.com/api/?name=${item.name}&color=ff0000&size=40&background=random`} />
																			</div>
																			{item.name.charAt(0).toUpperCase() +
																			item.name.slice(1)}{" "}
																			<span style={{ marginLeft: "0px" }}>
																			{getFormattedDate(
																				item.timestamps || item.timestamp,
																				"hh:mm a"
																			)}{" "}
																			{`(${moment(
																				item.timestamps || item.timestamp
																			).fromNow()})`}
																			</span>
																		</div>
																		{chatDetail &&
																			chatDetail.chat_type === "alie" && (
																			<div
																				style={{
																				display: "flex",
																				alignItems: "center",
																				gap: "12px",
																				}}
																			>
																				<div
																				className="review-button"
																				onClick={() => {
																					toggleReviewStatus(
																					item,
																					hindex
																					);
																				}}
																				style={{
																					cursor: "pointer",
																				}}
																				>
																				<svg
																					className={`${
																					item.review_status == 1
																						? "in-review"
																						: ""
																					}`}
																					viewBox="0 0 24 24"
																					fill="none"
																					xmlns="http://www.w3.org/2000/svg"
																				>
																					<g
																					id="SVGRepo_bgCarrier"
																					stroke-width="0"
																					></g>
																					<g
																					id="SVGRepo_tracerCarrier"
																					stroke-linecap="round"
																					stroke-linejoin="round"
																					></g>
																					<g id="SVGRepo_iconCarrier">
																					<path
																						opacity="0.5"
																						fill-rule="evenodd"
																						clip-rule="evenodd"
																						d="M6.5 1.75C6.5 1.33579 6.16421 1 5.75 1C5.33579 1 5 1.33579 5 1.75V21.75C5 22.1642 5.33579 22.5 5.75 22.5C6.16421 22.5 6.5 22.1642 6.5 21.75V13.6V3.6V1.75Z"
																					></path>
																					<path d="M13.3486 3.78947L13.1449 3.70801C11.5821 3.08288 9.8712 2.9258 8.22067 3.25591L6.5 3.60004V13.6L8.22067 13.2559C9.8712 12.9258 11.5821 13.0829 13.1449 13.708C14.8385 14.3854 16.7024 14.5119 18.472 14.0695L18.6864 14.0159C19.3115 13.8597 19.75 13.298 19.75 12.6538V5.28673C19.75 4.50617 19.0165 3.93343 18.2592 4.12274C16.628 4.53055 14.9097 4.41393 13.3486 3.78947Z"></path>
																					</g>
																				</svg>
																				</div>
																				<Whisper
																				placement="bottom"
																				trigger="hover"
																				speaker={
																					<Tooltip>
																					{copyChatLink ==
																					item.interaction_id
																						? "Copied"
																						: "Copy"}
																					</Tooltip>
																				}
																				>
																				<div
																					style={{
																					display: "flex",
																					cursor: "pointer",
																					}}
																					onClick={() => {
																					//Copy URL to Clipboard
																					console.log(
																						"Copy URL to Clipboard",
																						item
																					);
																					setCopyChatLink(
																						item.interaction_id
																					);
																					setTimeout(() => {
																						setCopyChatLink("");
																					}, 2000);
																					navigator.clipboard.writeText(
																						`${window.location.origin}/chat/${transcriptId}#${item.interaction_id}`
																					);
																					}}
																				>
																					<i
																					style={{
																						color:
																						copyChatLink ==
																						item.interaction_id
																							? "#0063e1"
																							: "#000000",
																					}}
																					class="fa fa-link"
																					></i>
																				</div>
																				</Whisper>
																			</div>
																			)}
																		</p>
																		<div
																			class={`mssg-text`}
																			style={{
																				textAlign: "left"
																			}}
																			onMouseUp={(e) => {
																				highlightSelection(e, hindex);
																				handleMouseUp(e);
																			}}
																			>
																			{item.hasOwnProperty("msg") ? (
																				<span
																				dangerouslySetInnerHTML={{
																					__html: createHyperlinks(item.msg),
																				}}
																				></span>
																			) : (
																				item.msg
																			)}
																			{item.interaction_id && (
																				<div
																				className="interactions-button"
																				onClick={() => {
																					setSelectedInteractionsId(
																					item.interaction_id
																					);
																					setShowInteractionsModal(true);
																				}}
																				title="View Interactions"
																				>
																				<svg
																					xmlns="http://www.w3.org/2000/svg"
																					width="16px"
																					height="16px"
																					viewBox="0 0 50 50"
																				>
																					<path d="M49.04,24.001l-1.082-0.043h-0.001C36.134,23.492,26.508,13.866,26.042,2.043L25.999,0.96C25.978,0.424,25.537,0,25,0	s-0.978,0.424-0.999,0.96l-0.043,1.083C23.492,13.866,13.866,23.492,2.042,23.958L0.96,24.001C0.424,24.022,0,24.463,0,25	c0,0.537,0.424,0.978,0.961,0.999l1.082,0.042c11.823,0.467,21.449,10.093,21.915,21.916l0.043,1.083C24.022,49.576,24.463,50,25,50	s0.978-0.424,0.999-0.96l0.043-1.083c0.466-11.823,10.092-21.449,21.915-21.916l1.082-0.042C49.576,25.978,50,25.537,50,25	C50,24.463,49.576,24.022,49.04,24.001z"></path>
																				</svg>
																				</div>
																			)}
																			{(item.reaction == 1 ||
																				item.reaction == 2) && (
																				<div className="reaction-icons">
																				{item.reaction == 1 && (
																					<svg
																					className="liked"
																					viewBox="0 0 24 24"
																					xmlns="http://www.w3.org/2000/svg"
																					>
																					<path
																						d="M8 10V20M8 10L4 9.99998V20L8 20M8 10L13.1956 3.93847C13.6886 3.3633 14.4642 3.11604 15.1992 3.29977L15.2467 3.31166C16.5885 3.64711 17.1929 5.21057 16.4258 6.36135L14 9.99998H18.5604C19.8225 9.99998 20.7691 11.1546 20.5216 12.3922L19.3216 18.3922C19.1346 19.3271 18.3138 20 17.3604 20L8 20"
																						stroke="#000000"
																						stroke-width="1.5"
																						stroke-linecap="round"
																						stroke-linejoin="round"
																					/>
																					</svg>
																				)}
																				{item.reaction == 2 && (
																					<svg
																					className="disliked"
																					viewBox="0 0 24 24"
																					xmlns="http://www.w3.org/2000/svg"
																					>
																					<path
																						d="M8 10V20M8 10L4 9.99998V20L8 20M8 10L13.1956 3.93847C13.6886 3.3633 14.4642 3.11604 15.1992 3.29977L15.2467 3.31166C16.5885 3.64711 17.1929 5.21057 16.4258 6.36135L14 9.99998H18.5604C19.8225 9.99998 20.7691 11.1546 20.5216 12.3922L19.3216 18.3922C19.1346 19.3271 18.3138 20 17.3604 20L8 20"
																						stroke="#000000"
																						stroke-width="1.5"
																						stroke-linecap="round"
																						stroke-linejoin="round"
																					/>
																					</svg>
																				)}
																				</div>
																			)}
																		</div>
																		{displayIcon && hindex == chatIndex ? (
																			<PopOver
																				obj={{
																					transcriptId,
																					chatIndex,
																					userUUID,
																					applyColor,
																					userList,
																					getChatNotes,
																					setDisplayIcon,
																					updateChat,
																					chatContent,
																					removeColor,
																				}}
																			/>
																		) : (
																			""
																		)}
																	</div>
																</div>
															);
														}
													})
												) : (
													<NoDataFound title="No History Found" />
												)
											) : (
												<React.Fragment>
													<div className="single-recieve">
														<div className="img-box">
															<Skeleton circle width="24px" height={"24px"} />
														</div>
														<div className="mssg-dec">
															<div>
																<Skeleton count={1} />
															</div>
															<Skeleton count={3} />
														</div>
													</div>
													<div className="single-sender">
														<div className="mssg-dec">
															<div>
																<Skeleton count={1} />
															</div>
															<Skeleton count={3} />
														</div>

														<div className="img-box">
															<Skeleton circle width="24px" height={"24px"} />
														</div>
													</div>
													<div className="single-recieve">
														<div className="img-box">
															<Skeleton circle width="24px" height={"24px"} />
														</div>
														<div className="mssg-dec">
															<div>
																<Skeleton count={1} />
															</div>
															<Skeleton count={3} />
														</div>
													</div>
													<div className="single-sender">
														<div className="mssg-dec">
															<div>
																<Skeleton count={1} />
															</div>
															<Skeleton count={3} />
														</div>

														<div className="img-box">
															<Skeleton circle width="24px" height={"24px"} />
														</div>
													</div>
												</React.Fragment>
											)}
										</div>
									</div>
								</div>
								<InteractionsModal
									interactionId={selectedInteractionsId}
									showModal={showInteractionsModal}
									setShowModal={setShowInteractionsModal}
								/>
								<div class="col-md-3 chat-padding-0 offcanvas-impl">
									<OffCanvas showCanvas={showCanvas} offCanvas={offCanvas} data={chatDetail} />
									<div class="chat-middle">
										{/* <div className="chat-header"> */}
										<div class="chat-right-title chat-title-pagination">
											<span>Notes</span>{" "}
										</div>
										{/* </div> */}
										<div class="note-viewarea" ref={noteContainerRef}>
											{noteError ? (
												<label className="note-error-msg">Please fill the field*</label>
											) : (
												""
											)}

											<form class="form-area">
												{Object.keys(userList).length > 0 && (
													<EditorNew
														getEditorData={addChatNote}
														noteAdd={noteAdd}
														show_toolbar={true}
														field_name="chat_note"
														edit_id={editId}
														noteAdding={noteAdding}
														// users={userList || {}}
														users={activeUserList}
													/>
												)}
											</form>
											<div class="note-content-area">
												{chatNotes.data &&
													chatNotes.data.map((item) => {
														return (
															<div
																class="single-content customer-chat-details"
																data-hash={"noteId" + item.custom_note_uuid}
															>
																<div class="noimg-box">
																	<img
																		src={
																			userList[item.user_uuid] &&
																			userList[item.user_uuid].profile_pic
																		}
																	/>
																</div>
																<div class="item-area">
																	<div class="title-area">
																		<h5 className="headelink">
																			<a
																				href={
																					userList[item.user_uuid] &&
																					userList[item.user_uuid].profile_url
																				}
																			>
																				{userList[item.user_uuid] &&
																					userList[item.user_uuid].name}
																			</a>{" "}
																			<CopyLink
																				custom_note_uuid={item.custom_note_uuid}
																				transcriptId={transcriptId}
																			/>
																		</h5>
																	</div>
																	<div class="snote">
																		Note{" "}
																		<a
																			target="_blank"
																			href={`/chat/${transcriptId}#noteId${item.custom_note_uuid}`}
																		>
																			{item.custom_note_uuid}
																		</a>{" "}
																		|{" "}
																		{moment(unix(item.created_timestamp)).format(
																			"D  MMM YYYY, h:mm:ss a"
																		)}
																	</div>

																	<div class="text-area">
																		{item.highlight_text ? (
																			<blockquote
																				class="quote-card"
																				dangerouslySetInnerHTML={{
																					__html: item.highlight_text,
																				}}
																			></blockquote>
																		) : (
																			""
																		)}
																		<div
																			dangerouslySetInnerHTML={{
																				__html: convertNoteList(
																					item.note_content
																				),
																			}}
																		></div>
																	</div>
																</div>
															</div>
														);
													})}
											</div>
										</div>
									</div>
								</div>
							</React.Fragment>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default withRouter(ChatDetails);




// WEBPACK FOOTER //
// ./src/components/chat/ChatDetails.js